const {generateReportData} = require('./stock-situation-export')

// returns the data to be used in tests
async function exportStockSituationData (state, locationId, serviceId, period, options = {}) {
  return generateReportData(state, locationId, serviceId, period, options)
}

module.exports = { exportStockSituationData }
